<script setup lang="ts">
import { PhArrowRight } from '@phosphor-icons/vue'
import { inject } from 'vue'

import { useCarousel } from './use-carousel'
import { Button } from '../button'
import { classMerge } from '../utils'

import type { CarouselProps, WithClassAsProps } from './carousel-interface'

const props = defineProps<WithClassAsProps & CarouselProps>()

const { canScrollNext, scrollNext } = useCarousel()

const variant = inject<CarouselProps['variant']>('variant')
if (!variant) {
  throw new Error('Carousel next must be inside the carousel')
}

</script>

<template>
  <Button :disabled="!canScrollNext && props.useDisabledOpacity"
          :class="classMerge(
            'touch-manipulation',
            !props.showWhenCannotScroll && !canScrollNext ? 'hidden' : '',
            variant === 'simple'
              ? 'right-6 top-1/2 -translate-y-1/2 absolute p-0'
              : '',
            props.class,
          )"
          :variant="variant === 'simple' ? 'primary' : 'secondary'"
          type="icon-only"
          :use-disabled-opacity="props.useDisabledOpacity"
          @click="scrollNext">
    <slot>
      <PhArrowRight weight="bold"
                    class="h-4 w-4 text-current" />
      <span class="sr-only">Next Slide</span>
    </slot>
  </Button>
</template>
